import Vue from "vue";
import {
  fetchLoginStatus,
  fetchProfile,
  fetchLogout
} from "../helper/requestWithToken";

export const state = Vue.observable({
  isLogin: false,
  userInfo: {}
});

const store = {
  state,

  setLoginStatus(payload) {
    state.isLogin = payload;
  },
  setUserInfo(payload) {
    console.log(payload);
    state.userInfo = payload;
  },
  expireLogin() {
    state.isLogin = false;
    state.userInfo = {};
  },
  requestLoginStatus() {
    if(sessionStorage.getItem('accessToken')){
      store.setLoginStatus(true);
      return true;
    }else{
      return false;
    }
  //  return isLoginStatus()
  //     .then(response => {
  //       store.setLoginStatus(response);
  //       return response;
  //     })
  //     .catch(err => Promise.reject(err));

    // return fetchLoginStatus()
    //   .then(response => {
    //     store.setLoginStatus(response);
    //     return response;
    //   })
    //   .catch(err => Promise.reject(err));
  },
  isLoginStatus(){
    if(sessionStorage.getItem('accessToken')){
      store.setLoginStatus(true);
      return true;
    }else{
      return false;
    }
  },
  requestLogout() {

     return fetchLogout()
    //   .then(res => {
    //     console.log(res);
    //     if (res.code ==200&&res.msg =="ok") {
    //       store.expireLogin();
    //     }
    //   })
    //   .catch(err => Promise.reject(err));
  },
  requestUserInfo() {
    return fetchProfile()
      .then(response => {
        console.log(response.data);
        store.setUserInfo(response.data);
      })
      .catch(Promise.reject);
  }
};
export default store;

window.addEventListener("beforeunload", () => {
  localStorage.setItem("account", JSON.stringify(state));
});

// window.addEventListener("DOMContentLoaded", () => {
try {
  var account = JSON.parse(localStorage.getItem("account"));
} catch (error) {
  account = {};
}
state.isLogin = account.isLogin;
state.userInfo = account.userInfo;
// });
